import React from "react";
import PropTypes from "prop-types";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import { makeStyles } from "@material-ui/core/styles";
import Moment from "moment";
import $ from "jquery";
import "./datetimepicker/jquery.datetimepicker.full.js";
import "./datetimepicker/jquery.datetimepicker.min.css";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
}));

class DateTimePicker extends React.Component {
  componentDidMount() {
    this.$el = $(this.el);
    this.$el.datetimepicker({
	});
  }

  render() {
    return (
      <div>
        <input ref={(el) => (this.el = el)} />
      </div>
    );
  }
}
export default DateTimePicker;
